module.exports = __webpack_public_path__ + "img/img_tutorial_01.4159c8ae.svg";